import { doc, setDoc, updateDoc, increment, serverTimestamp } from "firebase/firestore";
import db from "./Firebase";

const today = () => new Date().toISOString().split("T")[0];

const SERVER = "https://myprofilecorner.com/api";

export async function trackEvent(slug, event) {
    if (!slug) return;
    const d = today();
    const ref = doc(db, "analytics", slug);
    try {
        await updateDoc(ref, {
            [`total_${event}`]: increment(1),
            [`daily.${d}.${event}`]: increment(1),
            visited_time: serverTimestamp(),
        });
    } catch {
        // Doc doesn't exist yet — create it, then add nested fields
        await setDoc(ref, {
            [`total_${event}`]: 1,
            visited_time: serverTimestamp(),
        });
        await updateDoc(ref, {
            [`daily.${d}.${event}`]: increment(1),
        });
    }
    // Trigger email notification (fire and forget)
    if (event === "views") {
        fetch(`${SERVER}/notify/${slug}`, { method: "POST" }).catch(() => {});
    }
}

export async function trackSource(slug, source) {
    if (!slug || !source) return;
    const ref = doc(db, "analytics", slug);
    try {
        await updateDoc(ref, {
            [`sources.${source}`]: increment(1),
        });
    } catch (e) {
        console.warn("trackSource error:", e);
    }
}

export function detectSource() {
    const params = new URLSearchParams(window.location.search);
    const utm = params.get("utm_source");
    if (utm) return utm.toLowerCase();
    const ref = document.referrer.toLowerCase();
    if (!ref) return "direct";
    if (ref.includes("whatsapp")) return "whatsapp";
    if (ref.includes("linkedin")) return "linkedin";
    if (ref.includes("facebook") || ref.includes("fb.com")) return "facebook";
    if (ref.includes("twitter") || ref.includes("t.co") || ref.includes("x.com")) return "twitter";
    if (ref.includes("instagram")) return "instagram";
    if (ref.includes("telegram")) return "telegram";
    if (ref.includes("google")) return "google";
    return "other";
}

// Parse Firestore data that may have flat dot-notation keys OR nested maps
export function parseSources(raw = {}) {
    const out = { ...(raw.sources || {}) };
    Object.keys(raw).forEach(key => {
        if (key.startsWith("sources.")) {
            const src = key.slice(8);
            out[src] = (out[src] || 0) + raw[key];
        }
    });
    return out;
}

export function parseDaily(raw = {}) {
    const out = { ...(raw.daily || {}) };
    Object.keys(raw).forEach(key => {
        const m = key.match(/^daily\.(\d{4}-\d{2}-\d{2})\.(\w+)$/);
        if (m) {
            const [, date, field] = m;
            if (!out[date]) out[date] = {};
            out[date][field] = (out[date][field] || 0) + raw[key];
        }
    });
    return out;
}
